<template>
    <transition name="fade">
        <!-- <div class="Viewer3D" v-show="viewer3DVisible" @click="toggleViewer3D()">
            <div class="v3-container" @click="$event.stopPropagation()"> -->
        <div class="Viewer3D" v-show="viewer3DVisible">
            <div class="v3-container">
            <!-- <div class="v3-container">     -->
                <!-- Toolbar -->
                <div class="v3-bar">
                    <p class="v3-bar-name">HF-Group 3D Viewer</p>
                    <div class="v3-bar-buttons">  
                        <md-button class="md-icon-button" @click="toggleViewer3D()" style="margin-right: 0;">
                            <CloseIcon class="closeIcon"/>
                        </md-button>
                    </div> 
                </div>


                <Canvas id="v3-canvasHF" class="v3-canvas" :style="{'width': detailLevel>0 ? 'calc(100% - 500px)' : '100%'}"/> 

                <!-- <div v-if="true" style="position: absolute; top: 1rem; left: 40%;">{{detailLevel}}</div> -->

                <div class="v3-sidepanel" v-if="detailLevel>0" :style="{'transform': detailLevel>0 ? 'translateX(0px)' : 'translateX(500px)'}">
                    <div class="v3-sidepanel-header">
                        <CloseIcon class="closeIcon v3-sidepanel-close" @click="closeSidepanel()"/>
                        <img class="v3-sidepanel-logo" :src="publicPath+'/media/HF Group/HF Group Logo.png'" alt="">
                    </div>
                    <div class="v3-sidepanel-content">
                        <span class="v3-sidepanel-title">{{level1.focusedModuleData.name}} {{level1.focusedModuleData.id}}</span>
                        <img class="v3-sidepanel-img" :src="publicPath + level1.focusedModuleData.picture" alt="">
                        <span class="v3-sidepanel-text"><b>Beschreibung:</b><br>{{level1.focusedModuleData.text}}</span>

                        <hr class="v3-sidepanel-seperator" v-if="detailLevel == 2" style="position: relative; width: 100%;">

                        <span v-if="detailLevel == 2" class="v3-sidepanel-title">{{level2.focusedModuleData.name}} {{level2.focusedModuleData.id}}</span>
                        <img  v-if="detailLevel == 2" class="v3-sidepanel-img" :src="publicPath + level2.focusedModuleData.picture" alt="">
                        <span v-if="detailLevel == 2" class="v3-sidepanel-text"><b>Beschreibung:</b><br>{{level2.focusedModuleData.text}}</span>
                    </div>
                </div>
                
                
                <!-- Loadingscreen -->
                <div id="v3-loadingScreen" class="v3-loadingscreen">
                    <div>
                        <svg class="ls-animation" version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                            <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                                <animateTransform attributeName="transform" attributeType="XML"  type="rotate" dur="1s" from="0 50 50" to="360 50 50" repeatCount="indefinite" />
                            </path>
                        </svg>
                    </div>
                </div>

                <transition name="fade">
                    <div class="v3-displayName" v-if="displayName != ''">{{displayName}}</div>
                </transition>
            </div>         

        </div>  
    </transition>
</template>
    
<script>
import {mapMutations} from 'vuex';
import * as BABYLON from 'babylonjs';
import * as BABYLONGUI from 'babylonjs-gui';
import 'babylonjs-loaders';
import modulesData from "../../../public/media/HF Group/3DViewer/modules2.json";

// Icons
import CloseIcon from 'vue-material-design-icons/Close.vue'
import OpenInNewIcon from 'vue-material-design-icons/OpenInNew.vue'

export default {
    components: {CloseIcon,OpenInNewIcon},
    data: function () {
        this.publicPath = process.env.BASE_URL,
        this.highlightLayer = null,

        this.lod0ID = null,
        this.lod1ID = null,

        this.disableModelSwitch = false,
        this.buttonsNodeID = null,

        this.displayName = ""

        return {
            level1:{
                focusedModuleData: null,
                buttonsNodeID: null,
            },
            level2:{
                focusedModuleData: null,
                buttonsNodeID: null,
            },
            detailLevel: 0,
            buttonsNodeID: null,
            meshesLoaded: false,
            viewer3DVisible: false,
        }
    },
    computed: {
        modules() {
            return modulesData;
        },
    },
    watch:{
        meshesLoaded(){
            if(this.meshesLoaded){
                var buttonNode = new BABYLON.TransformNode("Buttons",window.scene3DViewer);
                this.buttonsNodeID = buttonNode.id;

                var buttonNode1 = new BABYLON.TransformNode("Level1",window.scene3DViewer);
                buttonNode1.parent = buttonNode;
                this.level1.buttonsNodeID = buttonNode1.id;

                var buttonNode2 = new BABYLON.TransformNode("Level2",window.scene3DViewer);
                buttonNode2.parent = buttonNode;
                this.level2.buttonsNodeID = buttonNode2.id;
                
                this.modules.forEach((module) => {
                    this.createButton(module,0);
                });
            }
        },
        detailLevel(){
            var ease = new BABYLON.CubicEase();
            ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
            switch(this.detailLevel){
                case 0:
                    BABYLON.Animation.CreateAndStartAnimation("", window.scene3DViewer.activeCamera , "target", 60,20, window.scene3DViewer.activeCamera.target,  new BABYLON.Vector3.Zero(), 0, ease);
                    break;
                case 1: 
                    this.highlightModuleData = this.level1.focusedModuleData;
                    console.log(this.level1.focusedModuleData.buttonPosition);
                    // Set Camera Target
                    var target = this.level1.focusedModuleData.buttonPosition ? 
                        new BABYLON.Vector3(this.level1.focusedModuleData.buttonPosition.x,this.level1.focusedModuleData.buttonPosition.y,this.level1.focusedModuleData.buttonPosition.z)
                        : window.scene3DViewer.getNodeByID(this.level1.focusedModuleData.linkedNodes[0]).position.multiply(new BABYLON.Vector3(-.0005,.0005,.0005));
                    BABYLON.Animation.CreateAndStartAnimation("", window.scene3DViewer.activeCamera , "target", 60,20, window.scene3DViewer.activeCamera.target, target, 0, ease);
                    
                    this.sidePanelOpen = true; 
                    break;
                case 2: 
                    this.highlightModuleData = this.level2.focusedModuleData;
                    console.log(this.level2.focusedModuleData.buttonPosition)
                    var target = this.level2.focusedModuleData.buttonPosition ? 
                        new BABYLON.Vector3(this.level2.focusedModuleData.buttonPosition.x,this.level2.focusedModuleData.buttonPosition.y,this.level2.focusedModuleData.buttonPosition.z)
                        : window.scene3DViewer.getNodeByID(this.level2.focusedModuleData.linkedNodes[0]).position;
                    BABYLON.Animation.CreateAndStartAnimation("", window.scene3DViewer.activeCamera , "target", 60,20, window.scene3DViewer.activeCamera.target, target, 0, ease);
                    this.sidePanelOpen = true;  
                    break; 
            }
        }
    },
	methods: {
        ...mapMutations(["setDialogueOpen"]),
        toggleViewer3D(){
            this.viewer3DVisible = !this.viewer3DVisible;
            this.setDialogueOpen(this.viewer3DVisible);
            if(this.viewer3DVisible){
                window.scene3DViewer.activeCamera.alpha = 3.1;
                window.scene3DViewer.activeCamera.beta = 1.2;
                window.engine3DViewer.runRenderLoop(()=> { window.scene3DViewer.render(); });
            }else{
                window.engine3DViewer.stopRenderLoop();
            }
        },
        initScene(){
            console.log("Initialize Scene");
            const canvas = document.getElementById("v3-canvasHF");
            window.engine3DViewer = new BABYLON.Engine(canvas, true, { stencil: true, xrCompatible: false });

            function customLoadingScreen() {}
            customLoadingScreen.prototype.displayLoadingUI = function () {
                window.document.getElementById("v3-loadingScreen").style.opacity = 1;
            };
            customLoadingScreen.prototype.hideLoadingUI = function () {
                window.document.getElementById("v3-loadingScreen").style.opacity = 0;
            };
            window.engine3DViewer.loadingScreen = new customLoadingScreen();

            window.scene3DViewer = new BABYLON.Scene(window.engine3DViewer);
            window.scene3DViewer.clearColor = new BABYLON.Color3(1,1,1);

            // window.scene3DViewer.environmentTexture = new BABYLON.Texture(this.publicPath + "/media/STÜBBE/3DViewer/ENV.jpg", window.scene3DViewer);
            window.scene3DViewer.environmentTexture = BABYLON.CubeTexture.CreateFromPrefilteredData(this.publicPath + "/media/HF Group/3DViewer/ENV.env", window.scene3DViewer);
            let dome = new BABYLON.PhotoDome("",this.publicPath + "/media/HF Group/Presses.jpg", { resolution:32, faceForward: false, size: 50}, window.scene3DViewer);
            dome.mesh.material.alpha = 0.2;
            dome.rotation.y = 2;

            this.highlightLayer = new BABYLON.HighlightLayer("", window.scene3DViewer);
            this.highlightLayer.innerGlow = false;
            
            this.glowLayer = new BABYLON.GlowLayer("", window.scene3DViewer);
            this.glowLayer.intensity = 0.1;

            var camera = new BABYLON.ArcRotateCamera("Camera", 2,  1.25, 5, new BABYLON.Vector3(0, 0, 0), window.scene3DViewer);
            camera.upperAlphaLimit = 50;
            camera.lowerAlphaLimit = -50;
            camera.lowerRadiusLimit = 1;
            camera.upperRadiusLimit = 10;
            camera.panningSensibility = 50;
            camera.minZ = 0.1;
            camera.maxZ = 100;
            camera.attachControl(canvas, true, false,4);
            camera.wheelPrecision = 40;

            var light = new BABYLON.HemisphericLight("HemiLight", new BABYLON.Vector3(0, 1, 0), window.scene3DViewer);
            
            canvas.addEventListener('pointerdown', () => {
                // this.closeSidepanel();
            });

            const resizeObserver = new ResizeObserver(() => {
                setTimeout(() => {
                    window.engine3DViewer.resize();
                }, 0);
            });
            
            resizeObserver.observe(canvas);
            // window.scene3DViewer.debugLayer.show();
        },
        initMeshes(){
            console.log("Create Meshes");
            var assetsManager = new BABYLON.AssetsManager(window.scene3DViewer);

            // var meshTask1 = this.assetsManager.addMeshTask("", "",this.publicPath + "/media/HF Group/3DViewer/" ,"Dreiviertelschnitt.glb");
            var meshTask1 = assetsManager.addMeshTask("", "",this.publicPath + "/media/HF Group/3DViewer/" ,"Curemaster_LOD1.glb");
            meshTask1.onSuccess = (task) => {  
                var lod1 = task.loadedMeshes[0];
                console.log(lod1);
                this.lod1ID = lod1.uniqueID;
                lod1.scaling = new BABYLON.Vector3(.5,.5,.5);
                lod1.position = new BABYLON.Vector3(0,0,0);
                lod1.setEnabled(true);

                window.engine3DViewer.resize();      
            }

            assetsManager.onFinish = () => {
                window.scene3DViewer.meshes.forEach(mesh => {
                    if(!mesh.name.includes("button"))
                        mesh.isPickable = false;
                    if(mesh.material)
                        mesh.material.backFaceCulling = true;
                        // mesh.doNotSyncBoundingInfo = true;
                        
                });
                this.meshesLoaded = true;
                window.scene3DViewer.useMaterialMeshMap = true; // performance optimization ?
            };
            assetsManager.load();
        },
        createButton(module,detailLevelID){
            // button design
            var base = new BABYLONGUI.Ellipse();
            base.background =  ""; 
            base.color = "black";
            base.hoverCursor = "pointer";
            base.thickness = 40;
            
            let button = BABYLON.MeshBuilder.CreatePlane("button"+module.id,{width:.2,height:.2},window.scene3DViewer);
            button.renderingGroupId = 1;
            button.visibility = 0;
            switch(detailLevelID){
                case 0: button.parent = window.scene3DViewer.getNodeByID(this.level1.buttonsNodeID); break;
                case 1: button.parent = window.scene3DViewer.getNodeByID(this.level2.buttonsNodeID); break;
                default: button.parent = window.scene3DViewer.getNodeByID(this.buttonsNodeID); break;
            }
            button.position = module.buttonPosition ? 
                button.position = new BABYLON.Vector3(module.buttonPosition.x,module.buttonPosition.y,module.buttonPosition.z) 
                : button.position = window.scene3DViewer.getNodeByID(module.linkedNodes[0]).position.multiply(new BABYLON.Vector3(-.0005,.0005,.0005));
            
            button.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;
            var advancedTexture = BABYLONGUI.AdvancedDynamicTexture.CreateForMesh(button);
            advancedTexture.addControl(base);
            
            var text = new BABYLONGUI.TextBlock();
            text.text = "" + (Number(module.id)+1);
            text.color = "black";
            text.fontSize = 700;
            base.addControl(text);

            var ease = new BABYLON.CubicEase();
            ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
            button.actionManager = new BABYLON.ActionManager(window.scene3DViewer);


            const nodes = window.scene3DViewer.getNodeByID(module.linkedNodes);


            // On-Create Animation
            BABYLON.Animation.CreateAndStartAnimation("", button, "visibility", 30,10, button.visibility, 1, 0, ease);

            // Click event
            button.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger,() => {
                button.isPickable = false;

                if(module.components){
                    this.level1.focusedModuleData = module;
                    this.detailLevel = 1;
                } else {
                    this.level2.focusedModuleData = module;
                    this.detailLevel = 2;
                }

                BABYLON.Animation.CreateAndStartAnimation("", button, "visibility", 30,10, button.visibility, 0, 0, ease, () => {
                    window.scene3DViewer.getNodeByID(this.buttonsNodeID).getChildMeshes().forEach((button) => {
                        button.setEnabled(false);
                    })                    

                    if(module.components){
                        module.components.forEach((component) => {
                            this.createButton(component,1);
                        })
                    }

                });                
            }));
        
            // Hover animation
            button.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger,() => {
                BABYLON.Animation.CreateAndStartAnimation("", button, "scaling", 30,10, button.scaling, new BABYLON.Vector3.One().scale(1.1), 0, ease);
                if(!this.sidePanelOpen) this.displayName = module.name;

                let text = module.id;

                window.scene3DViewer.getNodeByID(this.buttonsNodeID).getChildMeshes().forEach(button => {
                    if(button.name.replace("button","") != text){
                        BABYLON.Animation.CreateAndStartAnimation("", button, "visibility", 60,20, button.visibility, 0.1, 0, ease);
                    } 
                });
                
                this.transparencyHover(module.linkedNodes,0.1);
            }));

            button.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger,() => {   
                BABYLON.Animation.CreateAndStartAnimation("", button, "scaling", 30,10, button.scaling, new BABYLON.Vector3.One(), 0, ease);  
                if(!this.sidePanelOpen) this.displayName = "";  
                let text = module.id+1;

                if((!this.sidePanelOpen && detailLevelID==0) || detailLevelID==1 && this.detailLevel!=2){
                    window.scene3DViewer.getNodeByID(this.buttonsNodeID).getChildMeshes().forEach(button => {
                        if(button.text != text){
                            BABYLON.Animation.CreateAndStartAnimation("", button, "visibility", 60,20, button.visibility, 1, 0, ease);
                        }
                    })
                    switch(detailLevelID){
                        case 0: this.transparencyHover([],1); break;
                        case 1: this.transparencyHover(this.level1.focusedModuleData.linkedNodes,0.1); break;
                    }
                    
                } 
            }));
        },
        closeSidepanel(){
            // this.sidePanelOpen = false;
            // this.displayName = "";
            
            var ease = new BABYLON.CubicEase();
            ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);

            console.log(this.detailLevel);
            switch(this.detailLevel){
                case 0: break;
                case 1:
                    window.scene3DViewer.getNodeByID(this.level2.buttonsNodeID).getChildMeshes().forEach(button => {
                        BABYLON.Animation.CreateAndStartAnimation("", button, "visibility", 60,20, button.visibility, 0, 0, ease, () => {
                            button.dispose();
                            window.scene3DViewer.getNodeByID(this.level1.buttonsNodeID).getChildMeshes().forEach(button => {
                                button.setEnabled(true);
                                button.isPickable = true;
                                BABYLON.Animation.CreateAndStartAnimation("", button, "visibility", 60,20, button.visibility, 1, 0, ease);
                            });
                            this.transparencyHover([],1);
                            this.sidePanelOpen = false;
                        });
                    });
                    
                    
                    break;
                case 2:
                    window.scene3DViewer.getNodeByID(this.level2.buttonsNodeID).getChildMeshes().forEach(button => {
                        button.setEnabled(true);
                        button.isPickable = true;
                        BABYLON.Animation.CreateAndStartAnimation("", button, "visibility", 60,20, 0, 1, 0, ease);
                    }); 
                    this.transparencyHover(this.level1.focusedModuleData.linkedNodes,0.1);
                    break;
            }
            
            this.detailLevel -= 1;
            if(this.detailLevel < 0) this.detailLevel = 0;

            // if(window.scene3DViewer.getTransformNodeByUniqueId(this.buttonsNodeID).getChildMeshes()[0].visibility < 1){
            //     setTimeout(() => {
            //         window.scene3DViewer.getTransformNodeByUniqueId(this.buttonsNodeID).getChildMeshes().forEach(button => {
            //             BABYLON.Animation.CreateAndStartAnimation("", button, "visibility", 30, 10, button.visibility, 1, 0, null);
            //         });  
            //     }, 10);
            // }
        },
        transparencyHover(array,value){
            var ease = new BABYLON.CubicEase();
            ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);

            if(array.length>0){
                window.scene3DViewer.getNodeByID("__root__").getChildMeshes().forEach(mesh => {

                    if(!array.find(nodeName => nodeName == mesh.name || nodeName == mesh.parent.name)){
                        BABYLON.Animation.CreateAndStartAnimation("", mesh, "visibility", 60,20, mesh.visibility, value, 0, ease);
                    } else {
                        BABYLON.Animation.CreateAndStartAnimation("", mesh, "visibility", 60,20, mesh.visibility, 1, 0, ease);
                    }
                })
            } else {
                window.scene3DViewer.getNodeByID("__root__").getChildMeshes().forEach(mesh => {
                    BABYLON.Animation.CreateAndStartAnimation("", mesh, "visibility", 60,20, mesh.visibility, value, 0, ease);
                })
            }
        }
    },
    mounted: function(){
        window.addEventListener('openViewer3DHFGroup',this.toggleViewer3D);
        this.initScene();
        this.initMeshes();
        // this.currentProductlv1 = this.buttons[0];
        console.log(window.scene3DViewer);
        // this.toggleViewer3D(); // später rausnehmen
    },
    created: function(){
        
    },
    destroyed: function(){
        window.engine3DViewer.stopRenderLoop();
        window.scene3DViewer.dispose();
        window.engine3DViewer.dispose();
    }
}
</script>

<style scoped>
    .Viewer3D{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #000000d0;
    }
    .v3-container{
        position: absolute;
        margin-top: 30px;
        background: white;
        border-radius: 10px;
        transition: width .4s ease, height .4s ease;
        width: 85%;
        height: 85%;
        border-radius: 10px;
        overflow: hidden;
    }
    .v3-bar{
        background: white;
        padding: 3px;
        padding-right: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.774);
        display: flex;
        position: relative;
        z-index: 2;
    }
    .v3-bar-name{
        width: 100%;
        text-align: center;
        font-size: 18px;
        margin: auto 0;
    }
    .v3-bar-buttons{
        margin-left: auto;
    }
    .v3-canvas{
        width: 100%;
        height: calc(100% - 46px);
        outline: none;
        transition: width .3s ease;
        display: inline-flex;
    }
    .v3-canvas-container{
        height: 100%;
        overflow: visible;
    }
    .material-design-icon {
        height: 2.4em;
        width: 2.4em;
    }
    .material-design-icon > .material-design-icon__svg {
        fill: black;
        height: 2.4em;
        width: 2.4em;
    }
    .v3-active .material-design-icon  > .material-design-icon__svg{
        fill: white !important;
    }
    .v3-active.md-button{
        background: var(--primaryColor);
    }
    .md-button{
        background: transparent;
        padding: 0;
        width: 30px;
    }
    .material-design-icon.closeIcon {
        height: 2.5em;
        width: 2.5em;
    }
    .material-design-icon.closeIcon> .material-design-icon__svg {
        fill: #E74011;
        height: 2.5em;
        width: 2.5em;
    }
    .material-design-icon.v3-sidepanel-close {
        height: 40px;
        width: 40px;
    }
    .material-design-icon.v3-sidepanel-close> .material-design-icon__svg {
        fill: #E74011;
        height: 40px;
        width: 40px;
    }
    .v3-loadingscreen{
        pointer-events: none;
        opacity: 0;
        transition: 1s opacity ease-in-out;
        position: absolute;
        width: 100%;
        height: calc(100% - 46px);
        background: white;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 0px 0px 10px 10px;
    }
    .v3-logo{
        width: 350px;
    }
    .v3-animation{
        fill: var(--primaryColor);
        width: 200px;
        height: 200px;
        margin: auto;
        display: block;
    }
    .v3-displayName{
        position: absolute;
        top: 60px;
        left: 0;
        margin: 20px;
        font-size: 32px;
        color: black;
    }
    .v3-sidepanel{
        width: 500px;
        height: 100%;
        background: white;
        color: black;
        transition: transform .3s ease;
        padding-top: 0px;
        display: inline-flex;
        flex-direction: column;
        vertical-align: top;
        position: absolute;
        z-index: 0;
    }
    .v3-sidepanel-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;

        background: radial-gradient(circle at 100% -100px,transparent 45%,#003874 46%),
        radial-gradient(circle at 100% -140px,transparent 45%,#044d9b 45%);;
    }
    .v3-sidepanel-close{
        align-self: flex-start;
        cursor: pointer;
    }
    .v3-sidepanel-logo{
        width: 100px;
    }
    .v3-sidepanel-content{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 16px;
        margin-bottom: 64px;
        overflow-x: hidden;
        overflow-y: auto;

    }
    .v3-sidepanel-title{
        text-align: center;
        font-size: 26px;
        line-height: 30px;
        align-items: flex-start;
        color: #003874;
        font-weight: 500;
    }
    .v3-sidepanel-img{
        width: 80%;
        min-width: 400px;
            align-self: center;
    }
    .v3-sidepanel-text{
        font-size: 16px;
        width: 100%;
        min-height: 50px;
        background-color: rgb(250, 250, 250);
        padding: 8px;
        margin-bottom: 40px;
    }
    .switch {
        position: absolute;
        bottom: 0;
        left: 50%;
        text-align: center;
        color: white;
        width: 200px;
        height: 20px;
        cursor: pointer;
        
        margin-bottom: 20px;
        display: inline-block;
        width: 60px;
        height: 34px;
        transition: left .3s ease;
    }
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgb(134, 134, 134);
        -webkit-transition: .4s;
        transition: .4s;
        border-radius: 34px;
    }
    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
        border-radius: 50%;
    }
    input:checked + .slider {
        background-color: #2196F3;
    }
    input:focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }
    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }
</style>